export default "__VITE_ASSET__CskB1cTg__"